import { Alert, IconButton } from "@mui/material";
import { AlertPopupProps } from "components/types";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

export const AlertPopupMobile: React.FC<AlertPopupProps> = ({
  loading,
  alertMsg,
  autoClose,
  changes,
  isSuccess,
  handleSubmit,
  handleCloseAlert,
  className,
  styles,
}) => {
  const [showAlert, setShowAlert] = useState<boolean>(true);

  useEffect(() => {
    setShowAlert(true);
    if (!loading) {
      setTimeout(() => {
        setShowAlert(false);
      }, 4000);
    }
  }, [loading]);

  const handleAlertClose = () => {
    setShowAlert(false);
  };

  return (
    <>
      {showAlert && (
        <Alert
          icon={false}
          className={className}
          sx={{
            background:
              loading || changes ? "#323232" : isSuccess ? "green" : "#cc0000",
            boxShadow:
              "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px rgba(0, 0, 0, 0.14), 0px 1px 18px rgba(0, 0, 0, 0.12)",
            borderRadius: "4px",
            position: "absolute",
            zIndex: "2",
            marginLeft: "auto",
            marginRight: "auto",
            right: "0",
            top: "-77px",
            display: "flex",
            justifyContent: "center",
            height: "fit-content",
            width: "fit-content",
            alignItems: "center",
            ...styles,
          }}
        >
          {loading ? (
            <span
              style={{
                color: "white",
                fontFamily: "Lato",
              }}
            >
              Submitting...
            </span>
          ) : alertMsg ? (
            <span
              style={{
                color: "white",
                fontFamily: "Lato",
              }}
            >
              {alertMsg}
              <IconButton
                onClick={handleAlertClose}
                sx={{
                  position: "absolute",
                  padding: "0px",
                  right: "1px",
                  top: "3px",
                }}
              >
                <CloseIcon sx={{ fontSize: "16px" }} />
              </IconButton>
            </span>
          ) : (
            <>
              {changes && (
                <>
                  <span
                    style={{
                      color: "white",
                      fontFamily: "Lato",
                    }}
                  >
                    {changes.length + " changes made"}
                  </span>
                  <span
                    style={{
                      color: "#74d2f0",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontFamily: "Lato",
                    }}
                    onClick={handleSubmit}
                  >
                    Save
                  </span>
                  <span
                    style={{
                      color: "white",
                      fontSize: "16px",
                    }}
                  >
                    |
                  </span>
                  <span
                    style={{
                      color: "#74d2f0",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontFamily: "Lato",
                    }}
                    onClick={handleCloseAlert}
                  >
                    Close
                  </span>
                </>
              )}
            </>
          )}
        </Alert>
      )}
    </>
  );
};
